import { useQuery } from '@tanstack/react-query';
import _ from 'lodash';

import { BaseError } from 'helpers/BaseError';

// models
import {
    ContentCoverageFilters,
    FormulaCoverageMap,
} from '../../models/personalization.model';
import { ALL_USERS_AUDIENCE_ID } from 'models/audience.model';

// services
import API from '../../services/api';

import _queryKeys from './_queryKeys';

const getMap = async (
    xAxisComponentTypeId: string,
    yAxisComponentTypeId: string,
    labelIdX: number,
    labelIdY: number,
    filters: ContentCoverageFilters,
): Promise<any> => {
    const backendFilters = _.cloneDeep(filters) || {};

    if (backendFilters.audience_ids) {
        backendFilters.audience_ids = backendFilters.audience_ids.map((id) =>
            id === ALL_USERS_AUDIENCE_ID ? null : id,
        );
    }

    Object.keys(backendFilters ?? {}).forEach((key) => {
        if (backendFilters) {
            const value = backendFilters[key as keyof ContentCoverageFilters];

            if (Array.isArray(value) && value[0] === 'All') {
                delete backendFilters[key as keyof ContentCoverageFilters];
                return;
            }
        }
    });

    const params = {
        component_type_id_y: yAxisComponentTypeId,
        component_type_id_x: xAxisComponentTypeId,
        label_x_id: labelIdX,
        label_y_id: labelIdY,
        filters: backendFilters,
    };
    const { data } = await API.getFormulaCoverage(params);
    return data;
};

export default function useGetFormulaCoverage(
    xAxisComponentTypeId: string,
    yAxisComponentTypeId: string,
    labelIdX: number,
    labelIdY: number,
    filters: ContentCoverageFilters = {},
) {
    const queryKey: (string | number | ContentCoverageFilters)[] =
        _queryKeys.getFormulaCoverageMap(
            xAxisComponentTypeId,
            yAxisComponentTypeId,
            labelIdX,
            labelIdY,
            filters,
        );

    return useQuery<FormulaCoverageMap[], BaseError>({
        queryKey: queryKey,

        queryFn: () =>
            getMap(
                xAxisComponentTypeId,
                yAxisComponentTypeId,
                labelIdX,
                labelIdY,
                filters,
            ),
        enabled: !!(
            xAxisComponentTypeId &&
            yAxisComponentTypeId &&
            labelIdX &&
            labelIdY
        ),
        retry: false,
    });
}
